<template>
  <div class="footer">
    <a href="/cookies.html" target="_blank">{{ this.$store.state.labels.cookie_label }}</a>&nbsp;-&nbsp;
    <a href="https://www.whirlpool.eu/privacy-notice.html" target="_blank">{{ this.$store.state.labels.privacy_label }}</a>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  data() {
    return {
    }
  },
  mounted () {
  },
  created () {
  },
}
</script>
